import React from 'react';

import { Control } from 'react-hook-form';
import { observer } from 'mobx-react';
import { LbInput, LbSelect, LbDatePicker } from '@infoods/lifebase-ui';

import {
  InputBox,
  PhoneNumberInput,
} from '../../../../../shared/components/form-components';
import {
  validateEmail,
  validatePercent,
} from '../../../../../shared/utils/reactHookFormUtils';
import { CoachInfoFormValue } from '../../../../interfaces/CoachData';
import { genderOptions } from '../../../../../shared/constants/user-info/gender';
import { loggedInUserDataStore } from '../../../../../shared/stores/loggedInUserDataStore';
import { PaymentFlowTypeFlags } from '../../../../../shared/constants/user-info/paymentFlowType';
import { useUserRoleLabel } from '../../../../../shared/hooks/useUserRoleLabel';

type CoachInfoFormSectionProps = {
  control: Control<CoachInfoFormValue>;
  paymentFlowType: PaymentFlowTypeFlags;
};

const CoachInfoFormSection = observer(
  ({ control, paymentFlowType }: CoachInfoFormSectionProps) => {
    const { isCoach } = loggedInUserDataStore;
    const { getForAgent } = useUserRoleLabel();

    const privateInfoProps = { InputProps: { className: 'private-info' } };

    const generalInputProps = {
      control,
      size: 'small',
      variant: 'standard',
      ...privateInfoProps,
    } as const;

    return (
      <InputBox title={`${getForAgent()} Info`}>
        <LbInput
          {...generalInputProps}
          label="First Name"
          name="firstName"
          rules={{
            required: 'First name is required',
          }}
        />
        <LbInput
          {...generalInputProps}
          label="Last Name"
          name="lastName"
          rules={{
            required: 'Last name is required',
          }}
        />
        <LbInput {...generalInputProps} label="Job Title" name="additional.jobTitle" />
        <LbInput
          {...generalInputProps}
          label="Email"
          name="email"
          type="email"
          rules={{
            required: 'Email is required',
            validate: { validateEmail },
          }}
        />
        <PhoneNumberInput
          {...generalInputProps}
          label="Phone Number"
          name="additional.cellPhone"
          rules={{
            required: 'Cell phone is required',
          }}
        />
        <LbSelect
          {...generalInputProps}
          label="Gender"
          name="additional.gender"
          options={genderOptions}
        />
        <LbDatePicker
          {...generalInputProps}
          label="Date of Birth"
          name="additional.dateOfBirth"
        />
        <LbInput {...generalInputProps} label="Facebook" name="additional.facebook" />
        <LbInput {...generalInputProps} label="Instagram" name="additional.instagram" />
        {!paymentFlowType.NEW_USER_FLOW_2024 && !isCoach && (
          <>
            <LbInput
              {...generalInputProps}
              label="Commission setup (%)"
              name="additional.commissionSetUp"
              type="number"
              rules={{
                validate: { validatePercent },
              }}
            />
            <LbInput
              {...generalInputProps}
              label="Commission renew (%)"
              name="additional.commissionRenew"
              type="number"
              rules={{
                validate: { validatePercent },
              }}
            />
          </>
        )}
      </InputBox>
    );
  },
);

export { CoachInfoFormSection };
